import api from './axios';
import { CapitalMetricsResponse, CapitalStatusResponse, CapitalReadinessResponse } from './types'

const capitalApi = {
    // GET /capital/metrics
    getCapitalMetrics: async (business_id?: string): Promise<CapitalMetricsResponse> => {
        try {
            const config = business_id ? { params: { business_id } } : {};
            const response = await api.get<CapitalMetricsResponse>('/capital/metrics', config);
            return response.data;
        } catch (error: any) {
            console.error('Failed to fetch capital metrics:', error);
            throw new Error('Unable to fetch capital metrics');
        }
    },

    // GET /capital/status
    getCapitalStatus: async (business_id?: string): Promise<CapitalStatusResponse> => {
        try {
            const config = business_id ? { params: { business_id } } : {};
            const response = await api.get<CapitalStatusResponse>('/capital/status', config);
            return response.data;
        } catch (error: any) {
            console.error('Failed to fetch capital status:', error);
            throw new Error('Unable to fetch capital status');
        }
    },

    // GET /capital/readiness
    getCapitalReadiness: async (business_id?: string): Promise<CapitalReadinessResponse> => {
        try {
            const config = business_id ? { params: { business_id } } : {};
            const response = await api.get<CapitalReadinessResponse>('/capital/readiness', config);
            return response.data;
        } catch (error: any) {
            console.error('Failed to fetch capital readiness:', error);
            throw new Error('Unable to fetch capital readiness');
        }
    },
};

export default capitalApi;
